import React from "react";
import { empiTheme } from "./styles/empiTheme";

export default function WhyDifferent() {
  return (
    <section style={section}>
      <div style={container}>
        <div style={eyebrow}>Why EmPi is different</div>
        <h2 style={h2}>Built for daily rhythm, not generic tracking.</h2>

        <div style={split} className="empi-split">
          <div style={box}>
            <div style={label}>EmPi is not:</div>
            <ul style={ul}>
              <li>a mood journal</li>
              <li>a generic wellness app</li>
              <li>a symptom tracker</li>
              <li>medical diagnosis software</li>
            </ul>
          </div>

          <div style={boxAlt}>
            <p style={p}>
              EmPi is a daily body-rhythm guide. It helps you align food,
              movement, and focus with how your body actually feels today.
            </p>

            <p style={p}>
              No rigid plans. No judgmental language. Just clear options that
              adapt to your cycle day, energy, and real schedule.
            </p>

            <p style={pLast}>
              Built for real variability — because humans aren’t the same every
              day.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

const section = {
  padding: empiTheme.layout.sectionPadding,
  background: empiTheme.colors.background,
};

const container = {
  maxWidth: empiTheme.layout.maxWidth,
  margin: "0 auto",
};

const eyebrow = {
  ...empiTheme.typography.eyebrow,
  color: empiTheme.colors.textSecondary,
  marginBottom: 12,
};

const h2 = {
  fontSize: empiTheme.typography.h2.fontSize,
  lineHeight: empiTheme.typography.h2.lineHeight,
  margin: "0 0 18px",
  color: empiTheme.colors.text,
  maxWidth: 760,
};

const split = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 16,
};

const boxBase = {
  border: `1px solid ${empiTheme.colors.border}`,
  borderRadius: empiTheme.radius.card,
  padding: 18,
  boxShadow: empiTheme.shadow.card,
};

const box = {
  ...boxBase,
  background: empiTheme.colors.surface,
};

const boxAlt = {
  ...boxBase,
  background: "#FAFAFA",
};

const label = {
  fontWeight: 700,
  marginBottom: 10,
  color: empiTheme.colors.text,
};

const ul = {
  margin: 0,
  paddingLeft: 18,
  lineHeight: 1.9,
  color: empiTheme.colors.textSecondary,
  fontSize: 15,
};

const p = {
  margin: "0 0 12px",
  lineHeight: 1.65,
  color: empiTheme.colors.text,
  fontSize: 16,
};

const pLast = {
  margin: 0,
  lineHeight: 1.65,
  color: empiTheme.colors.text,
  fontSize: 16,
};
